import useAdAccountDashboardStore from 'auth/lib/useAdAccountDashboardStore';
import { DocumentNode } from 'graphql';

export default function getUpdateAdAccountPinnedResult(__: DocumentNode, variables: Record<string, any>) {
	const { clientId, adAccountPinned } = variables;

	useAdAccountDashboardStore.getState().updateAdAccountSettings(clientId, { isPinned: adAccountPinned });

	return {
		adAccountPinned,
		adAccountId: clientId,
		clientId,
	};
}
